import Head from 'next/head';
import { useTranslation } from 'next-i18next';
interface Props {
  title: string;
}

const PageMeta: React.FC<Props> = ({ title }) => {
  const { t } = useTranslation(['common']);
  return (
    <Head>
      <title>{`${title} - ${t('common:yv_connect')}`}</title>
      <meta charSet='utf-8' />
      <meta content='initial-scale=1.0, width=device-width' name='viewport' />
    </Head>
  );
};

export default PageMeta;
